import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // <-- Tailwind styles are pulled in here
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./services/authInstance";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  // </React.StrictMode>
);

reportWebVitals();
